import { darken, lighten, Skeleton } from "@mui/material";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_KNOCKOUT_JUNIOR } from "helpers/FONT";
import { SPACING } from "helpers/spacings";
import React from "react";

export default function Splash({ loading = false, title, descriptionHeader, descriptionValue, color }) {
  const colorDarken = darken(color, 0.5);
  const colorSkeleton = lighten(color, 0.5);

  return (
    <>
      <div
        style={{
          backgroundColor: color,
          color: COLOR_WHITE,
          background: `linear-gradient(0deg, ${color}, ${colorDarken})`,
          display: "flex",
          flexFlow: "row wrap",
          alignItems: "center",
          padding: 40,
          paddingBottom: 20,
          paddingLeft: 25,
          gap: 40,
        }}
      >
        <div
          style={{
            display: "flex",
            flexFlow: "column nowrap",
            gap: 10,
            margin: "0 auto",
            maxWidth: MAX_CONTENT_WIDTH,
            width: `calc(100vw - ${SPACING} * 2)`,
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: `min(40px, 7vw)`,
              textTransform: "uppercase",
              fontFamily: FONT_FAMILY_KNOCKOUT_JUNIOR,
              fontWeight: 300,
            }}
          >
            {title || (loading && <Skeleton style={{ width: "5em", backgroundColor: colorSkeleton }} />)}
          </h1>
          <div
            style={{
              textTransform: "uppercase",
              fontFamily: FONT_FAMILY_KNOCKOUT_JUNIOR,
              opacity: 0.5,
            }}
          >
            {descriptionHeader || (loading && <Skeleton style={{ width: "2em", backgroundColor: colorSkeleton }} />)}
          </div>
          <h2
            style={{
              margin: 0,
              textTransform: "uppercase",
              fontFamily: FONT_FAMILY_KNOCKOUT_JUNIOR,
              fontWeight: 300,
              fontSize: 18,
            }}
          >
            {descriptionValue || (loading && <Skeleton style={{ width: "5em", backgroundColor: colorSkeleton }} />)}
          </h2>
        </div>
      </div>
    </>
  );
}
